const STATS = [
  { value: "+100mil", label: "Visitas anuales a locales", sub: "Tráfico cualificado cada mes" },
  { value: "+2000", label: "Negocios activos", sub: "Anunciantes recurrentes en plataforma" },
  { value: "10mil +", label: "Anuncios en Bizaclia Portal", sub: "Propiedades de todas las categorías" },
  { value: "48h", label: "Primer contacto", sub: "Tiempo medio hasta interesado real" },
];

export function Stats() {
  return (
    <section className="py-20 sm:py-24">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl mb-12">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">
            Bizaclia Portal®
          </span>
          <h2 className="mt-3 font-display font-bold text-4xl sm:text-5xl tracking-tight">
            Tecnología que te conecta con interesados de calidad cada día
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Miles de visitas, contactos verificados y herramientas que aceleran
            cada operación inmobiliaria de tu negocio.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-3xl border border-border bg-card p-6 hover:border-primary/40 transition"
            >
              <div className="font-display font-bold text-4xl sm:text-5xl text-primary tracking-tight">
                {s.value}
              </div>
              <div className="mt-3 font-semibold text-foreground">{s.label}</div>
              <p className="mt-1 text-sm text-muted-foreground">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
